import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { MapPin, Hotel, Globe } from "lucide-react";


function SearchBar() {
  const [destination, setDestination] = useState("");
  const [results, setResults] = useState([]);
  const [checkIn, setCheckIn] = useState("");
  const [checkOut, setCheckOut] = useState("");
  const [open, setOpen] = useState(false);
  const isInvalidDates = checkIn && checkOut && new Date(checkOut) <= new Date(checkIn);

  const navigate = useNavigate();

  const getIcon = (item) => {
  if (item.name) return <Hotel size={16} className="text-gray-500" />;
  if (item.city) return <MapPin size={16} className="text-gray-500" />;
  return <Globe size={16} className="text-gray-500" />;
};

const getLabel = (item) => {
  if (item.name) return item.name;
  if (item.city) return item.city;
  return item.island;
};

const getSubLabel = (item) => {
  if (item.name) return item.city;
  if (item.city) return item.island;
  return "";
};
const Item = ({ item }) => (
  <div
    onClick={() => {
      setDestination(item.name || item.city || item.island);
      setOpen(false);
    }}
    className="flex items-center gap-3 px-4 py-3 hover:bg-gray-50 cursor-pointer"
  >
    <div className="w-8 h-8 flex items-center justify-center bg-gray-100 rounded-lg">
      {getIcon(item)}
    </div>

    <div className="flex flex-col">
      <span className="text-sm font-medium text-gray-900">
        {getLabel(item)}
      </span>
      <span className="text-xs text-gray-500">
        {getSubLabel(item)}
      </span>
    </div>
  </div>
);

  // 🔥 autocomplete
  useEffect(() => {
    if (!destination) {
      setResults([]);
      return;
    }
    

    const delayDebounce = setTimeout(async () => {
      try {
        const res = await axios.get(
          `https://api.komorotel.com/api/hotels/search-suggestions`,
          {
            params: { destination }
          }
        );
        setResults(res.data);
        setOpen(true);
      } catch (err) {
        console.log(err);
      }
    }, 300);

    return () => clearTimeout(delayDebounce);
  }, [destination]);
  const hotels = results.filter(r => r.name);
    const cities = results.filter(r => !r.name && r.city);
    const islands = results.filter(r => !r.name && !r.city && r.island);

  // 🔥 search submit
  const handleSearch = () => {
    navigate(
        `/hotels?destination=${destination}&checkIn=${checkIn}&checkOut=${checkOut}`
    );
    };

  return (
    <div className="mt-10 w-full max-w-4xl relative">

      <div className="rounded-2xl bg-white p-4 shadow-xl">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">

          {/* DESTINATION */}
          <div className="relative">
            <input
              type="text"
              placeholder="Destination"
              value={destination}
              onChange={(e) => setDestination(e.target.value)}
              className="w-full rounded-xl border border-gray-300 px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#3A9D23]"
              onFocus={() => setOpen(true)}
            />
            {/* ❌ bouton X */}
                {destination && (
                    <button
                    onClick={() => setDestination("")}
                    className="
                        absolute right-3 top-1/2 -translate-y-1/2
                        text-gray-400 hover:text-gray-600
                    "
                    >
                    ✕
                    </button>
                )}

            {/* 🔥 DROPDOWN */}
            {open && results.length > 0 && (
                <div className="
                    absolute bottom-full left-0 w-full mb-2
                    bg-white border rounded-2xl shadow-xl z-50
                    overflow-hidden
                    max-h-64 overflow-y-auto
                    ">

                    {/* HOTELS */}
                    {hotels.length > 0 && (
                    <>
                        <div className="px-4 py-2 text-xs text-gray-400 font-semibold">
                        Hôtels
                        </div>
                        {hotels.map((item) => (
                        <Item key={item._id} item={item} />
                        ))}
                    </>
                    )}

                    {/* CITIES */}
                    {cities.length > 0 && (
                    <>
                        <div className="px-4 py-2 text-xs text-gray-400 font-semibold">
                        Villes
                        </div>
                        {cities.map((item) => (
                        <Item key={item._id} item={item} />
                        ))}
                    </>
                    )}

                    {/* ISLANDS */}
                    {islands.length > 0 && (
                    <>
                        <div className="px-4 py-2 text-xs text-gray-400 font-semibold">
                        Îles
                        </div>
                        {islands.map((item) => (
                        <Item key={item._id} item={item} />
                        ))}
                    </>
                    )}

                </div>
                )}
          </div>
          

          {/* DATES */}
                {/* DATES PREMIUM */}
        <div className="flex flex-col md:col-span-2">

          {/* LABEL GLOBAL MOBILE */}
          <span className="text-xs text-gray-400 mb-2 md:hidden">
            Dates de séjour
          </span>

          <div className="grid grid-cols-2 gap-3 md:gap-4">

            {/* CHECK-IN */}
            <div className="relative md:max-w-[180px]">
              <label className="absolute -top-2 left-3 bg-white px-1 text-[11px] text-gray-500">
                Arrivée
              </label>

              <input
                type="date"
                value={checkIn}
                onChange={(e) => setCheckIn(e.target.value)}
                min={new Date().toISOString().split("T")[0]}
                className={`
                  w-full rounded-lg border px-3
                  pt-4 pb-2 md:pt-3 md:pb-2
                  text-sm md:text-[14px]
                  transition bg-white text-gray-900
                  focus:outline-none focus:ring-2
                  ${
                    isInvalidDates
                      ? "border-red-300 bg-red-50 focus:ring-red-400"
                      : "border-gray-300 focus:ring-[#3A9D23]"
                  }
                `}
              />
            </div>

            {/* CHECK-OUT */}
            <div className="relative md:max-w-[180px]">
              <label className="absolute -top-2 left-3 bg-white px-1 text-[11px] text-gray-500">
                Départ
              </label>

              <input
                type="date"
                value={checkOut}
                onChange={(e) => setCheckOut(e.target.value)}
                min={checkIn || new Date().toISOString().split("T")[0]}
                className={`
                  w-full rounded-lg border px-3
                  pt-4 pb-2 md:pt-3 md:pb-2
                  text-sm md:text-[14px]
                  transition bg-white text-gray-900
                  focus:outline-none focus:ring-2
                  ${
                    isInvalidDates
                      ? "border-red-300 bg-red-50 focus:ring-red-400"
                      : "border-gray-300 focus:ring-[#3A9D23]"
                  }
                `}
              />
            </div>

          </div>

          {/* ERROR */}
          <div
            className={`
              text-xs mt-2 flex items-center gap-2
              transition-all duration-300
              ${
                isInvalidDates
                  ? "opacity-100 text-red-500"
                  : "opacity-0 h-0"
              }
            `}
          >
            <span>⚠️</span>
            <span>La date de départ doit être après l’arrivée</span>
          </div>

        </div>

          {/* BUTTON */}
          <button
            onClick={handleSearch}
            disabled={isInvalidDates}
            className={`
                rounded-xl py-3 font-semibold text-white transition
                ${
                isInvalidDates
                    ? "bg-gray-300 cursor-not-allowed"
                    : "bg-[#3A9D23] hover:bg-[#33891E]"
                }
            `}
            >
            Rechercher
            </button>

        </div>
      </div>

    </div>
  );
}

export default SearchBar;